/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BusinessInfo from './BusinessInfoold';
import BusinessKeys from '../Business/BusinessKeys';
import Maintenance from '../../../../functions/logic/Maintenance';
import Spiner from '../../../../components/Spiner';
import { useSnackbar } from 'notistack';
import FormModal from '../../../../components/FormModal';
import ConfirmModal from '../../../../components/ConfirmModal';
import BusinessParameters from './BusinessParametersOld';



export default function Business() {
    const param = useParams();
    const [spiner, setSpiner] = useState(false);
    const [BusinessInfoData, setBusinessInfo] = useState([]);
    const [paramInfoData, setParamInfoData] = useState([]);
    const [paramInfoIva, setParamInfoIva] = useState([]);
    const [businessImg, setBusinessImg] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [direction, setDirection] = useState("");
    const userToken = localStorage.getItem('userToken');
    const { enqueueSnackbar } = useSnackbar();
    const [parameterId, setParameterId] = useState(0);
    const [isOpenModalform, setIsOpenModalForm] = useState(false);
    const [isOpenModalConfirm, setIsOpenModalConfirm] = useState(false);
    const [saveType, setSaveType] = useState('I');
    const [paramEditData, setParamEditData] = useState([]);
    const [media, setMedia] = useState([]);


    useEffect(() => {
        setSpiner(true);
        getBusinessInfo(param);
        setSpiner(false);
    }, [param]);

    const getBusinessInfo = async (param) => {
        global.MENU_MODULE_SELECT = 'mantenimiento'
        localStorage.setItem('param', JSON.stringify(param.moduleId));
        const response = await Maintenance.businessInfo(userToken, param.moduleId);
        if (response[0].length > 0) {
            setBusinessImg(response[0][0]['path_img']);
            setName(response[0][0]['name']);
            setEmail(response[0][0]['email']);
            setDirection(response[0][0]['direction']);
        }
        setBusinessInfo(response[0]);
        setParamInfoData(response[1]);
        setParamInfoIva(response[2]);
    }


    const handledSave = async (event) => {
        setSpiner(true);
        event.preventDefault();
        const response = await Maintenance.saveBusinessInfoLogic(userToken, param.moduleId, event.target);
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        });
        setTimeout(function () {
            getBusinessInfo(param);
        }, global.DELAY);
        setSpiner(false);
    };

    const handledSaveImg = async (event) => {
        setSpiner(true);
        event.preventDefault();

        const newMedia = media;

        if (!newMedia || newMedia.length === 0) {
            enqueueSnackbar('No se ha seleccionado ninguna imagen', {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            });
            setSpiner(false);
            return;
        }

        const formData = new FormData();
        newMedia.forEach((item, index) => {
            formData.append(`media${index}`, item.file);
        });

        const response = await Maintenance.saveBusinessIMGLogic(userToken, param.moduleId, newMedia);

        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
        });

        window.location.reload();
        setSpiner(false);
    };


    const handledDelete = async (e) => {
        setSaveType("D")
        setSpiner(true);
        setParameterId(e);
        setIsOpenModalConfirm(true);
        setSpiner(false);
    }

    const handledEdit = async (e) => {
        setSaveType("E")
        setSpiner(true);
        setParameterId(e);
        const response = await Maintenance.parameterByIdLogic(userToken, param.moduleId, e);
        setParamEditData(response)
        setIsOpenModalForm(true);
        setSpiner(false);
    }

    const handledSaveParam = async (event) => {
        setSpiner(true);
        event.preventDefault();
        const response = await Maintenance.saveParameterLogic(userToken, param.moduleId, event.target, parameterId, saveType);
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        });
        setTimeout(function () {
            getBusinessInfo(param);
        }, global.DELAY);
        setSpiner(false);
        setIsOpenModalForm(false)
    };

    const handleCloseModal = () => {
        setIsOpenModalForm(false)
        setIsOpenModalConfirm(false)
        cleanStorage();
    };

    const handledNew = async () => {
        cleanStorage();
        setSaveType("I")
        setParameterId(0);
        setSpiner(true);
        setParamEditData([])
        setIsOpenModalForm(true);
        setSpiner(false);
    }

    const handledConfirmDelete = async (e) => {
        setSpiner(true);
        const response = await Maintenance.saveParameterLogic(userToken, param.moduleId, '', parameterId, saveType);
        setSpiner(false);
        setIsOpenModalConfirm(false)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        });
        setTimeout(function () {
            getBusinessInfo(param);
        }, global.DELAY);
    }

    const handledUpdateIva = async (event) => {
        setSpiner(true);
        event.preventDefault();
        const response = await Maintenance.saveParameterLogic(userToken, param.moduleId, event.target, 0, 'UI');
        setSpiner(false);
        setIsOpenModalConfirm(false)
        enqueueSnackbar(response.message, {
            variant: response.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        });
        setTimeout(function () {
            getBusinessInfo(param);
        }, global.DELAY);
    }

    const cleanStorage = () => {
        localStorage.removeItem('nameParam');
        localStorage.removeItem('descriptionParam');
        localStorage.removeItem('valueDataParam');
        localStorage.removeItem('estausParam');
    }

    const handleMediaChange = (e) => {
        setSpiner(true);
        const files = Array.from(e.target.files);
        const validTypes = ['image/jpeg', 'image/png', 'video/webm'];
        const newMedia = [];
        let validationError = '';

        files.forEach((file) => {
            if (validTypes.includes(file.type)) {
                const mediaURL = URL.createObjectURL(file);
                newMedia.push({
                    file,
                    url: mediaURL,
                    type: 'image',
                });
                setMedia((prevMedia) => [...prevMedia, ...newMedia]);
            } else {
                validationError = 'Solo se permiten archivos de imagen JPEG, PNG, GIF y videos MP4, WEBM o OGG.';
            }
        });
        setSpiner(false);
    };

    return (
        <>
            <Spiner opt={spiner} />
            <FormModal
                isOpen={isOpenModalform}
                handleCloseModal={handleCloseModal}
                header={'Editar parametro'}
                button={'Guardar'}
                formData={paramEditData}
                handledSave={handledSaveParam}
                opt={'parameters'}
            />
            <ConfirmModal
                isOpen={isOpenModalConfirm}
                handleCloseModal={handleCloseModal}
                header={'Eliminar servicio'}
                body={'Estás seguro de inactivar el parametro'}
                button={'Inactivar'}
                formData={paramEditData}
                handledConfirmDelete={handledConfirmDelete}
            />
            <div className="content-wrapper">
                <section className="content-header">
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-2 text-center">
                                <div className="card card-primary card-outline">
                                    <div className="card-body box-profile">
                                        <div className="text-center">
                                            <img className="img-fluid img-profile" src={global.IMGPerfil + businessImg} alt="1" />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <div className="btn btn-primary btn-block mt-3">
                                                <label htmlFor="inputTag" className="mb-0">
                                                    Cambiar imagen <br />
                                                    <i className="fa fa-camera"></i>
                                                    <input id="inputTag" name="img" type="file" className="d-none" onChange={handleMediaChange} />
                                                </label>
                                            </div>

                                            <div style={{ marginTop: '12px' }}>
                                                <button
                                                    onClick={(e) => handledSaveImg(e)}
                                                    style={{ backgroundColor: '#28a745', color: 'white', border: 'none', height: '36px', padding: '8px 16px', cursor: 'pointer' }}
                                                >
                                                    Guardar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-10">
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill" href="#custom-tabs-three-home" role="tab" aria-controls="custom-tabs-three-home" aria-selected="true">
                                                    <i className="fas fa-building"></i> Información de la empresa
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-profile" role="tab" aria-controls="custom-tabs-three-profile" aria-selected="false">
                                                    <i className="fas fa-cogs"></i> Parametros generales
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-keys" role="tab" aria-controls="custom-tabs-three-keys" aria-selected="false">
                                                    <i className="fas fa-key"></i> Firma electrónica y calve de accesos
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-nfact" role="tab" aria-controls="custom-tabs-three-nfact" aria-selected="false">
                                                    <i className="fas fa-file-invoice"></i> Secuencial factura
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content" id="custom-tabs-three-tabContent">
                                            <div className="tab-pane fade show active" id="custom-tabs-three-home" role="tabpanel" aria-labelledby="custom-tabs-three-home-tab">
                                                <BusinessInfo data={BusinessInfoData} handledSave={handledSave} />
                                            </div>
                                            <div className="tab-pane fade" id="custom-tabs-three-profile" role="tabpanel" aria-labelledby="custom-tabs-three-profile-tab">
                                                <BusinessParameters handledUpdateIva={handledUpdateIva} paramInfoIva={paramInfoIva} paramInfoData={paramInfoData} handledEdit={handledEdit} handledDelete={handledDelete} handledNew={handledNew} />
                                            </div>
                                            <div className="tab-pane fade" id="custom-tabs-three-keys" role="tabpanel" aria-labelledby="custom-tabs-three-keys-tab">
                                                <BusinessKeys handledUpdateIva={handledUpdateIva} paramInfoIva={paramInfoIva} paramInfoData={paramInfoData} handledEdit={handledEdit} handledDelete={handledDelete} handledNew={handledNew} />
                                            </div>
                                            <div className="tab-pane fade" id="custom-tabs-three-nfact" role="tabpanel" aria-labelledby="custom-tabs-three-nfact-tab">
                                                <BusinessKeys handledUpdateIva={handledUpdateIva} paramInfoIva={paramInfoIva} paramInfoData={paramInfoData} handledEdit={handledEdit} handledDelete={handledDelete} handledNew={handledNew} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div >
        </>
    )
}